export const ActionTypes = {
  SET_COMPANY_STATUS: "SET_COMPANY_STATUS",
  SET_COMPANY_INFO: "SET_COMPANY_INFO",
  SET_COMPANY_USERS: "SET_COMPANY_USERS",
  FETCH_CONTENTFUL_DATA: "FETCH_CONTENTFUL_DATA",
  FETCH_CONTENTFUL_ANALYTICS_DATA: "FETCH_CONTENTFUL_ANALYTICS_DATA",
  SET_JOB_POSITION_DATA: "SET_JOB_POSITION_DATA",
  SET_TEAM_DATA: "SET_TEAM_DATA",
};
